import {
  GET_DUCS_CONFIG_REQUESTED,
  GET_DUCS_CONFIG_SUCCESS,
  GET_DUCS_CONFIG_ERROR
} from './actions';

export const initialState = {
  isFetching: false,
  url: null,
  config: null
};

const ducsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DUCS_CONFIG_REQUESTED:
      return {
        ...state,
        isFetching: true
      };
    case GET_DUCS_CONFIG_SUCCESS:
      return {
        ...state,
        isFetching: false,
        url: action.url,
        config: action.config
      };
    case GET_DUCS_CONFIG_ERROR:
      return {
        ...state,
        isFetching: false
      };
    default:
      return state;
  }
};

export default ducsReducer;



// WEBPACK FOOTER //
// ./containers/ducs/reducer.js